import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { SortHelper } from '@core/helpers/sort.helper';
import { Category } from '@interfaces/Category';
import { Estimate } from '@interfaces/Estimate';
import { TranslateService } from '@ngx-translate/core';
import { EstimateSettingsService } from '@shared/services/estimate-settings.service';
import { EstimateService } from '@shared/services/estimate.service';
import { Table } from 'primeng/table';
import { forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'pop-category-table',
  templateUrl: './category-table.component.html',
  styleUrls: ['./category-table.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class CategoryTableComponent implements OnInit {
  public categories: Category[];
  public colspanClassification = 0;
  public colspanInternalFees = 0;
  public currentEstimate: Estimate;
  public frozenCols: any[];
  public isLoading = false;
  public scrollableCols: any[];
  public currentLang: string;
  public activateInternalFees: boolean;

  @Input() public functionalCurrencySymbol: string;

  public constructor(
    private estimateService: EstimateService,
    private translateService: TranslateService,
    private estimateSettingsService: EstimateSettingsService
  ) {
    this.currentEstimate = <Estimate>{};
    this.categories = <Category[]>[];
    this.scrollableCols = [];
    this.currentLang = this.translateService.currentLang;
  }

  public async ngOnInit() {
    this.isLoading = true;
    this.currentEstimate = this.estimateService.currentEstimate;

    SortHelper.sortArrayByProperty(this.currentEstimate.classificationEstimates, o => o.classification?.code);

    this.currentEstimate.classificationEstimates.forEach(_ => {
      const col = {};
      this.scrollableCols = [col, ...this.scrollableCols];
    });

    this.colspanClassification = this.currentEstimate.classificationEstimates.length;
    this.colspanInternalFees = this.currentEstimate.internalResourceEstimates.length;

    // TODO : try to find another solution than this...
    const categoryObservables = this.currentEstimate.structures.map(structure => {
      const code = structure.categoryGroup ? structure.categoryGroup.code : '';
      return this.estimateService.getCategoriesByGroupCode(code).pipe(
        map(results => {
          for (const category of results) {
            const index = this.categories.indexOf(category);
            if (index === -1) {
              this.categories.push(category);
            }
          }
        })
      );
    });
    forkJoin(categoryObservables).subscribe(_ => {
      SortHelper.sortArrayByCode(this.categories);
    });

    const estimateConfig = await this.estimateSettingsService.getEstimateConfigurationAsync();
    this.activateInternalFees = estimateConfig.activateInternalFees;

    this.isLoading = false;
  }

  public filterTable(table: Table, eventTarget: EventTarget) {
    const input = eventTarget as HTMLInputElement;
    table.filterGlobal(input.value, 'contains');
  }
}
